const CAMPAIGN_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

export function safePageUrl() {
	const query = new URLSearchParams(location.search);
	const safe = new URLSearchParams();
	CAMPAIGN_KEYS.forEach(key => { if (query.has(key)) safe.set(key, query.get(key).slice(0, 100)); });
	return location.pathname + (safe.size ? `?${safe}` : "");
}

export function sessionAttribution(sessionId) {
	try {
		const saved = JSON.parse(localStorage.getItem("solufy_attribution") || "null");
		if (saved?.session_id === sessionId) return saved;
	} catch {}
	const query = new URLSearchParams(location.search);
	let referrer = "", domain = "";
	try {
		const url = new URL(document.referrer);
		if (url.origin !== location.origin) { referrer = url.origin + url.pathname; domain = url.hostname; }
	} catch {}
	const attribution = { session_id: sessionId, landing_page: location.pathname, referrer, referrer_domain: domain };
	CAMPAIGN_KEYS.forEach(key => { attribution[key] = (query.get(key) || "").slice(0, 100); });
	try { localStorage.setItem("solufy_attribution", JSON.stringify(attribution)); } catch {}
	return attribution;
}
